export const userNamePattern = new RegExp(/^[a-zA-Z +"  *"]{2,50}$/);
export const emailPattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/);
export const passwordPattern = new RegExp(/^(?=.*?)(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/);
